import { Box, Button, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGlobalConfig } from 'context/GlobalContext';
import { ROUTE_TREE } from 'routes/AppRoutes';
import { selectPilotList, selectSelectedPilotId } from 'store/dataReducers/pilotsSlice';
import PushUpdatesDialog from './PushUpdatesDialog';

export const PushUpdatesPage = () => {
  const { rc } = useGlobalConfig();
  const pilotList = useSelector(selectPilotList) as any[];
  const selectedPilotId = useSelector(selectSelectedPilotId);

  const selectedPilot = useMemo(
    () => pilotList.find((p) => p?.projectId === selectedPilotId),
    [pilotList, selectedPilotId]
  );

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    rc.uiRouter.navigate(ROUTE_TREE.PROJECT.DETAILS);
  };

  if (!selectedPilot) {
    return (
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          No project selected
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select a project first, then open Push Updates again.
        </Typography>
        <Button variant="contained" onClick={() => rc.uiRouter.navigate(ROUTE_TREE.PROJECT.DETAILS)}>
          Back to Project Details
        </Button>
      </Box>
    );
  }

  const environmentName =
    selectedPilot?.environment?.stack_name ||
    selectedPilot?.environment?.environment_name ||
    selectedPilot?.environment?.name ||
    selectedPilot?.name ||
    '';

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
        Pending Configuration Push
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Review and push staged configuration changes for <b>{environmentName}</b>.
      </Typography>

      <PushUpdatesDialog
        open={open}
        onClose={handleClose}
        environmentName={environmentName}
        projectId={selectedPilot.projectId}
      />
    </Box>
  );
};

